<template>
  <v-row no-gutters>
    <!-- باکس راهنمای متغیرها در حالت پترن -->
    <v-col cols="12" v-if="isPattern" class="mb-2 justify-start d-flex flex-row">
    <variable-picker
              v-if="isPattern"
              :text-value="text"
              @insert="insertVariableIntoTextarea"
              @remove="removeVariableFromText"
            />

      <v-alert
        dense
        text
        type="info"
        class="ma-0 text-caption"
        style="border-radius: 8px;"
      >
        <strong>راهنما:</strong> مکان‌نما را در جای دلخواه متن بگذارید و روی دکمه <strong>+</strong> کلیک کنید.
        <!-- <br /> -->
        می‌توانید تا ۵ متغیر دلخواه (مثلاً نام، مبلغ، کد و...) در متن قرار دهید.
      </v-alert>
    </v-col>

    <!-- کادر ورودی متن اصلی -->
    <v-col cols="12">
      <v-textarea
        v-if="rerender"
        ref="textarea"
        v-model="text"
        :disabled="disabled"
        :label="label"
        :rules="rules"
        class="default-text"
        filled
        outlined
        rows="8"
        auto-grow
        v-bind="$attrs"
      >
        <template v-if="!isWhatsapp && !disabled" v-slot:append>
          <div class="d-flex align-center">
            <v-btn
              small
              fab
              elevation="2"
              class="mx-1"
              title="هوش مصنوعی: تولید متن هوشمند"
              @click.stop="aiDialog = true"
            >
              <v-icon>✨</v-icon>
            </v-btn>
          </div>
        </template>

        <!-- دکمه‌های کناری تکست‌اریا (دسکتاپ) -->
        <template v-if="!disabled" v-slot:append-outer>
          <div
            v-if="$vuetify.breakpoint.smAndUp"
            class="d-flex flex-column fill-height justify-space-between py-2"
            style="height: 145px"
          >
            <!-- دکمه ایموجی -->
            <v-btn
              class="px-2"
              style="font-size: 1.5em"
              text
              title="ایموجی"
              @click="emojiModel = true"
            >
              <div class="pt-1">🙂</div>
            </v-btn>
            <!-- دکمه مشاور متن -->
            <v-btn
              v-if="textSuggest"
              class="px-2"
              style="font-size: 1.5em"
              text
              title="مشاور متن (رایگان)"
              @click="defaultModel = true"
            >
              <div>✉️</div>
            </v-btn>
            <!-- دکمه انتخاب کمپین -->
            <v-btn
              v-else
              class="px-2"
              style="font-size: 1.5em"
              text
              title="انتخاب کمپین"
              @click="$emit('openCamp')"
            >
              <div>✉️</div>
            </v-btn>

            <!-- دکمه لینک کوتاه -->
            <v-btn
              v-if="sendPagesTab !== 1"
              text
              title="لینک کوتاه"
              @click="openLink = true"
            >
              <v-icon color="blue lighten-2" large>mdi-link-variant</v-icon>
            </v-btn>
          </div>
        </template>
      </v-textarea>
    </v-col>

    <!-- پیش‌نمایش پترن -->
    <v-col cols="12" class="mt-1" v-if="isPattern">
      <v-switch
        v-model="Ptax"
        label="پیش‌نمایش پیامک:"
        inset
        dense
        class="preview-title text-caption ma-0 mb-1"
      />
      <div v-if="Ptax" class="sms-preview" v-html="highlightedText"></div>
    </v-col>

    <!-- دکمه‌های ابزار برای حالت موبایل -->
    <v-col v-if="$vuetify.breakpoint.xs" cols="12" class="d-flex align-center justify-space-around my-2">
      <!-- دکمه متغیرها (موبایل) -->
      <variable-picker
        v-if="isPattern"
        :text-value="text"
        @insert="insertVariableIntoTextarea"
        @remove="removeVariableFromText"
      />

      <!-- دکمه ایموجی -->
      <v-btn
        class="px-2"
        style="font-size: 1.5em"
        text
        title="ایموجی"
        @click="emojiModel = true"
      >
        <div>🙂</div>
      </v-btn>

      <!-- دکمه مشاور متن -->
      <v-btn
        v-if="textSuggest && !isWhatsapp"
        class="px-2"
        style="font-size: 1.5em"
        text
        title="مشاور متن (رایگان)"
        @click="defaultModel = true"
      >
        <div>✉️</div>
      </v-btn>

      <!-- دکمه انتخاب کمپین -->
      <v-btn
        v-if="!textSuggest && !isWhatsapp"
        class="px-2"
        style="font-size: 1.5em"
        text
        title="انتخاب کمپین"
        @click="$emit('openCamp')"
      >
        <div>✉️</div>
      </v-btn>

      <!-- دکمه لینک کوتاه -->
      <v-btn
        v-if="sendPagesTab !== 1"
        text
        title="لینک کوتاه"
        @click="openLink = true"
      >
        <v-icon color="blue lighten-2" large>mdi-link-variant</v-icon>
      </v-btn>
    </v-col>

    <!-- اطلاعات تعداد کاراکتر، پیامک و زبان -->
    <v-col class="d-block d-sm-flex mt-2" cols="12" v-if="!isWhatsapp">
      <p class="mx-2">
        <span v-text="$t('FORMS.CharCount')"></span> :
        <span class="font-weight-bold" v-text="' ' + textInfo.total"></span>
      </p>

      <v-spacer />
      <p class="mx-2">
        <span v-text="$t('FORMS.SmsCount')"></span> :
        <span class="font-weight-bold" v-text="' ' + textInfo.smsCount"></span>
      </p>

      <v-spacer />
      <p class="mx-2">
        <span v-text="$t('FORMS.SmsLang')"></span> :
        <span
          class="font-weight-bold"
          v-text="' ' + $t('LANGUAGE.' + textInfo.lang.name)"
        ></span>
      </p>

      <div class="d-none d-sm-block" style="width: 70px" />
    </v-col>

    <!-- پاپ‌آپ لینک کوتاه -->
    <custom-popup
      v-model="openLink"
      :cons="{ title: 'لینک کوتاه' }"
      hide-confirm
      persistent
      no-click-animation
      scrollable
      content-class="shortlink-dialog"
      reloadable
    >
      <select-short-link
        v-if="openLink"
        @close="openLink = false"
        @select="getShortLink"
      />
    </custom-popup>

    <!-- پاپ‌آپ ایموجی -->
    <custom-popup
      v-model="emojiModel"
      :cons="cons"
      hide-confirm
      max-width="500"
    >
      <emoji-selector :inputBox="$refs.textarea" @close="emojiModel = false" />
    </custom-popup>

    <!-- پاپ‌آپ متن پیش‌فرض -->
    <custom-popup v-model="defaultModel" :cons="cons1" hide-confirm>
      <default-sms
        v-if="defaultModel"
        :input-box="$refs.textarea"
        :title-box="titleInput"
        @selected="defaultModel = false"
      />
    </custom-popup>

    <!-- پاپ‌آپ هوش مصنوعی -->
    <ai-text-suggest-dialog
      v-if="!isWhatsapp"
      v-model="aiDialog"
      :input-box="$refs.textarea"
      :title-box="titleInput"
    />
  </v-row>
</template>

<script>
import EmojiSelector from "./emoji";
import DefaultSms from "./defaultSms.vue";
import { getTextSmsInfo, Language } from "@/Utilities/Utilities";
import SelectShortLink from "@/view/content/shortLink/selectShortLink.vue";
import { mapState } from "vuex";
import { debounce } from "@/main";
import AiTextSuggestDialog from "./AiTextSuggestDialog.vue";
import VariablePicker from "../../pages/text/VariablePicker.vue";

export default {
  name: "suggestText",

  components: {
    SelectShortLink,
    DefaultSms,
    EmojiSelector,
    AiTextSuggestDialog,
    VariablePicker,
  },

  props: {
    rules: Array,
    value: String,
    label: {
      required: false,
    },
    titleInput: [String, Object],
    disabled: Boolean,
    textSuggest: {
      type: Boolean,
      default: true,
    },
    isWhatsapp: {
      type: Boolean,
      default: false,
    },
    isPattern: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      Ptax: false,
      aiDialog: false,
      emojiModel: false,
      defaultModel: false,
      cons: {
        title: "انتخاب ایموجی",
      },
      cons1: {
        title: "متن پیشفرض",
      },
      textInfo: {
        total: 0,
        farsi: 0,
        smsCount: 0,
        lang: Language.English,
        price: 0,
        coefficient: 1,
        readNumberCount: 0,
      },
      openLink: false,
      shortLinkUrl: "",
      rerender: true,
      text: "",
    };
  },

  mounted() {
    this.text = this.value || "";
  },

  computed: {
    ...mapState("locals", ["sendPagesTab"]),
    highlightedText() {
      if (!this.text) return "";
      let safeText = this.text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return safeText
        .replace(/(data\d+)/gi, '<span class="data-highlight">$1</span>')
        .replace(/\n/g, "<br>");
    },
  },

  watch: {
    text(val) {
      if (!val) {
        this.$emit("input", "");
        return;
      }

      let formattedText = val
        .replace(/([^\s])(data\d+)/gi, "$1 $2")
        .replace(/(data\d+)([^\s\d])/gi, "$1 $2");

      if (formattedText !== val) {
        this.text = formattedText;
        return;
      }

      debounce(() => {
        this.$emit("input", val);

        let info = getTextSmsInfo(val);
        this.textInfo.total = val.length;
        this.textInfo.farsi = info.persianChar;
        this.textInfo.smsCount = info.smsCount;
        this.textInfo.lang = info.lang;

        this.$nextTick(() => {
          this.$emit("textInfo", this.textInfo);
        });
      }, 200);
    },
    value(val) {
      if (val !== this.text) this.text = val;
    },
  },

  methods: {
    getShortLink(val) {
      if (!!val) {
        let text = this.text;
        let index = text.indexOf("لغو11");

        this.text =
          text.slice(0, index) + "\n" + val + "\n" + text.slice(index);
      }
    },
    // متد درج متغیر در محل کرسر
    insertVariableIntoTextarea(variableValue) {
      const textarea = this.$refs.textarea?.$refs?.input;
      const currentText = this.text || "";

      let start =
        textarea && textarea.selectionStart !== undefined
          ? textarea.selectionStart
          : currentText.length;

      let end =
        textarea && textarea.selectionEnd !== undefined
          ? textarea.selectionEnd
          : start;

      this.text =
        currentText.substring(0, start) +
        variableValue +
        currentText.substring(end);

      this.$nextTick(() => {
        if (textarea) {
          textarea.focus();
          const position = start + variableValue.length;
          textarea.setSelectionRange(position, position);
        }
      });
    },
    // متد حذف متغیر
    removeVariableFromText(variableValue) {
      if (!this.text) return;
      this.text = this.text.split(variableValue).join("");
    },
  },
};
</script>

<style scoped>
.default-text >>> .v-input__append-outer {
  margin: 4px;
  height: 100%;
}
.shortlink-dialog {
  width: 95vw !important;
  max-width: 460px !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;
}

@media (min-width: 600px) {
  .shortlink-dialog {
    max-width: 560px !important;
  }
}

@media (min-width: 960px) {
  .shortlink-dialog {
    max-width: 800px !important;
  }
}

@media (min-width: 1264px) {
  .shortlink-dialog {
    max-width: 900px !important;
  }
}

.shortlink-dialog .v-card {
  height: 80vh;
  max-height: 700px;
  display: flex;
  flex-direction: column;
}

.shortlink-dialog .v-card__text {
  flex: 1;
  overflow-y: auto;
  padding: 0 !important;
}

.sms-preview {
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  min-height: 80px;
  white-space: pre-wrap;
  font-family: inherit;
  line-height: 1.8;
  border: 1px solid #e0e0e0;
}

.sms-preview >>> .data-highlight {
  color: #1976D2 !important;
  background-color: #E3F2FD;
  padding: 0 4px;
  border-radius: 4px;
  font-weight: bold;
}
</style>
